export const LBS_PER_MEAL = 'lbs_per_meal';
export const ATTACH_SITE_RADIUS_IN_MILES = 'attach_site_radius_in_miles';
